var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C6.90694 2 6 2.90694 6 4V6H4C2.895 6 2 6.895 2 8V17C2 18.105 2.895 19 4 19H6V20C6 21.0931 6.90694 22 8 22H16C17.0931 22 18 21.0931 18 20V19H20C21.105 19 22 18.105 22 17V8C22 6.895 21.105 6 20 6H18V4C18 2.90694 17.0931 2 16 2H8ZM9.5 5H14.5C14.776 5 15 5.224 15 5.5V6.5C15 6.776 14.776 7 14.5 7H9.5C9.224 7 9 6.776 9 6.5V5.5C9 5.224 9.224 5 9.5 5ZM4.5 8H6V17H4.5C4.224 17 4 16.776 4 16.5V8.5C4 8.224 4.224 8 4.5 8ZM18 8H19.5C19.776 8 20 8.224 20 8.5V16.5C20 16.776 19.776 17 19.5 17H18V8ZM9.5 9H14.5C14.776 9 15 9.224 15 9.5V10.5C15 10.776 14.776 11 14.5 11H9.5C9.224 11 9 10.776 9 10.5V9.5C9 9.224 9.224 9 9.5 9ZM9.5 13H14.5C14.776 13 15 13.224 15 13.5V14.5C15 14.776 14.776 15 14.5 15H9.5C9.224 15 9 14.776 9 14.5V13.5C9 13.224 9.224 13 9.5 13ZM9.5 17H14.5C14.776 17 15 17.224 15 17.5V18.5C15 18.776 14.776 19 14.5 19H9.5C9.224 19 9 18.776 9 18.5V17.5C9 17.224 9.224 17 9.5 17Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/Catalog.9f5dbff4c55dc1fe38e85063b5e4f703.svg";
export { ForwardRef as ReactComponent };